if (!customElements.get('ramayan-diwali-epilogue')) {
  customElements.define('ramayan-diwali-epilogue', class extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const revealItems = this.querySelectorAll('[data-rde-reveal]');
      revealItems.forEach((item) => item.classList.add('is-pending'));

      this.revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('is-pending');
          this.revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

      revealItems.forEach((item) => this.revealObserver.observe(item));
    }

    disconnectedCallback() {
      this.revealObserver?.disconnect();
    }
  });
}
